import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetHeaderComponent, AssetHeaderConfig } from '../../shared/components/asset-header/asset-header.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';

interface ResourceItem {
  id: string;
  title: string;
  description: string;
  fileName: string;
  downloadUrl: string;
}

@Component({
  selector: 'app-knowledge-hub',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    AssetHeaderComponent,
  ],
  templateUrl: './knowledge-hub.component.html',
  styleUrl: './knowledge-hub.component.scss',
})
export class KnowledgeHubComponent {
  headerConfig: AssetHeaderConfig = {
    breadcrumbs: [
      { label: 'Home', route: '/' },
      { label: 'Knowledge hub' }
    ],
    title: 'Knowledge hub',
    description: 'Browse the knowledge base and curated content. Find articles, guides, and resources to help you get the most out of TANUH.'
  };

  activeTab: 'resources' | 'stories' = 'resources';

  resources: ResourceItem[] = [];

  setActiveTab(tab: 'resources' | 'stories'): void {
    this.activeTab = tab;
  }

  get emptyStateHint(): string {
    return this.activeTab === 'resources'
      ? 'Resources will be available here shortly.'
      : 'Stories will be available here shortly.';
  }

  trackByResourceId(_: number, item: ResourceItem): string {
    return item.id;
  }
}
